import { render, staticRenderFns } from "./MasterPage.vue?vue&type=template&id=3f4db220&"
import script from "./MasterPage.vue?vue&type=script&lang=js&"
export * from "./MasterPage.vue?vue&type=script&lang=js&"
import style0 from "./MasterPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports